import { RouteRecordRaw } from "vue-router";
import { LAYOUT } from "../constants";
import { ManagerType } from "../constants";

export default [
  {
    path: "/player",
    redirect: "/player/list",
    name: "Player",
    component: LAYOUT,
    meta: {
      roles: ManagerType.OrganizationReviewer,
      title: "运动员管理",
      order: 70,
      icon: "ant-design:user-outlined",
    },
    children: [
      {
        path: "list",
        name: "PlayerPage",
        component: () => import("@/views/player/PlayerPage.vue"),
        meta: {
          title: "运动员列表",
          roles: ManagerType.OrganizationReviewer,
          icon: "ant-design:user-outlined",
        },
      },
      {
        path: "transfer",
        name: "PlayerTransferPage",
        component: () => import("@/views/transfer/PlayerTransferPage.vue"),
        meta: {
          title: "运动员转会",
          roles: ManagerType.OrganizationReviewer,
          icon: "solar:transfer-horizontal-outline",
        },
      },
      {
        path: "personal-join",
        name: "PlayerPersonalJoinReviewPage",
        component: () => import("@/views/personal/PersonalJoinReviewPage.vue"),
        meta: {
          title: "加入队伍审核",
          icon: "ix:join",
          roles: ManagerType.OrganizationReviewer,
          hideMenu: import.meta.env.VITE_PROJECT_ALIAS != "swm",
        },
      },
    ],
  },
] as RouteRecordRaw[];
